// extracted by mini-css-extract-plugin
module.exports = {"productColorOptionContainer":"GfColorList_productColorOptionContainer__2jWB_","productColorValidationErrorMessage":"GfColorList_productColorValidationErrorMessage__Devzc"};